import markerSDK, { MarkerSdk } from '@marker.io/browser';

export class MarkerService {
  private static instance: MarkerService;
  private markerClient: MarkerSdk | null = null;
  private PROJECT_ID = '643f37f822b278b60ffb91f8';

  public static getInstance(): MarkerService {
    if (!MarkerService.instance) {
      MarkerService.instance = new MarkerService();
    }
    return MarkerService.instance;
  }

  public async init() {
    if (!this.markerClient && window.innerWidth > 768) {
      try {
        this.markerClient = await markerSDK.loadWidget({
          project: this.PROJECT_ID,
        });
      } catch (error) {
        console.error('MarkerService - init error:', error);
      }
    }
  }

  public async initMobile() {
    if (!this.markerClient && window.innerWidth < 768) {
      try {
        this.markerClient = await markerSDK.loadWidget({
          project: this.PROJECT_ID,
        });

        this.markerClient.hide();

        this.markerClient.on('load', async () => {
          console.log('Marker.io Initiated');
          const isExtensionInstalled = await this.markerClient?.isExtensionInstalled();

          const user = JSON.parse(localStorage.getItem('user') ?? '{}');

          if (user && user.username && isExtensionInstalled) {
            this.markerClient?.setReporter({
              email: `${user.username}@vipclub.lv`,
              fullName: `${user.username}`,
            });
          }
        });
      } catch (error) {
        console.error('MarkerService - init error:', error);
      }
    }
  }

  public setClient() {
    try {
      const user = JSON.parse(localStorage.getItem('user') ?? '{}');

      if (user && user.username && this.markerClient) {
        this.markerClient.setReporter({
          email: `${user.username}@vipclub.lv`,
          fullName: `${user.username}`,
        });
      }
    } catch (error) {
      console.error('MarkerServiceClient - setClient', error);
    }
  }

  public setCustomData() {
    try {
      const geoData = JSON.parse(localStorage.getItem('geo') ?? '{}');
      let ip = 'N/A';

      if (geoData?.ip) {
        ip = geoData.ip + (geoData.country_name ? ` - Country: ${geoData.country_name}` : '');
      }

      const userAgent = navigator?.userAgent ?? 'N/A';

      const user = JSON.parse(localStorage.getItem('user') ?? '{}');
      const username = user?.username ?? 'N/A';

      if (this.markerClient)
        this.markerClient.setCustomData({
          ip: ip,
          userAgent: userAgent,
          url: location.href,
          username: username,
        });
    } catch (error) {
      console.error('MarkerServiceClient - setCustomData', error);
    }
  }

  public hide() {
    this.markerClient?.hide();
  }

  public show() {
    this.markerClient?.show();
  }

  public async isExtensionInstalled() {
    return this.markerClient?.isExtensionInstalled();
  }

  public capture(mode: 'fullscreen' | 'advanced') {
    return this.markerClient?.capture(mode);
  }
}

export const MarkerServiceClient = MarkerService.getInstance();
